"use client";

import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FilterBarProps {
  tags: string[];
  selectedTag: string | null;
  onTagChange: (tag: string | null) => void;
  label?: string;
}

export function FilterBar({ tags, selectedTag, onTagChange, label = "Filter by" }: FilterBarProps) {
  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium text-muted-foreground shrink-0">{label}:</span>
      {selectedTag && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onTagChange(null)}
          className="h-7 text-xs gap-1 text-destructive hover:text-destructive"
        >
          Clear <X className="w-3 h-3" />
        </Button>
      )}
      {tags.map((tag) => (
        <button
          key={tag}
          onClick={() => onTagChange(tag === selectedTag ? null : tag)}
          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            tag === selectedTag
              ? "bg-primary text-primary-foreground"
              : "bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary"
          }`}
        >
          {tag}
        </button>
      ))}
    </div>
  );
}
